"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const contact_details_entity_1 = require("./contact-details.entity");
const look_up_entity_1 = require("./look-up.entity");
let ChildDetails = class ChildDetails {
    constructor(childName, childDob, childGender, contactDetailsId, createdAt, updatedAt, createdBy, updatedBy, contactDetails, childGenderType) {
        this.childName = childName;
        this.childDob = childDob;
        this.childGender = childGender;
        this.contactDetailsId = contactDetailsId;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.contactDetails = contactDetails;
        this.childGenderType = childGenderType;
    }
};
exports.ChildDetails = ChildDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], ChildDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "child_name", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], ChildDetails.prototype, "childName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "child_dob", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], ChildDetails.prototype, "childDob", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "child_gender", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], ChildDetails.prototype, "childGender", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_details_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ChildDetails.prototype, "contactDetailsId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], ChildDetails.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], ChildDetails.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], ChildDetails.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ChildDetails.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ChildDetails.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_details_entity_1.ContactDetails, (contactDetails) => contactDetails.childDetails, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_details_id" }),
    tslib_1.__metadata("design:type", Object)
], ChildDetails.prototype, "contactDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "child_gender", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], ChildDetails.prototype, "childGenderType", void 0);
exports.ChildDetails = ChildDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)("child_details"),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, Number, Number, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object, Number, Number, Object, Object])
], ChildDetails);
